<template>
  <!-- -->
  <div class="banner-setting mini-component">
    <div class="desc">
      可以上传多张图片，图片尺寸无要求，但需要所有的图片尺寸一致
    </div>
    <div v-if="showList">
      <div v-for="(item, idx) in imageList" :key="idx" @click="toSetting(item, idx)">
        <alone-image-setting :data="item"/>
      </div>
      <page-button style="width: 100%" @click="addNew">添加图片</page-button>
    </div>
    <div v-else>
      <page-button @click="showList = true">返回</page-button>
      <alone-data v-model="currentData" @change="changeData" :show-tag="false" :show-background="false" :show-icon="false"/>
    </div>

  </div>
</template>

<script>

import AloneData from "@/views/h5/common/sys/miniProgram/setting/component/AloneData.vue";
import AloneImageSetting from "@/views/h5/common/sys/miniProgram/setting/component/AloneImageSetting.vue";

export default {
  emits: ["change"],
  props: {
    data: {
      type: Object,
      default: () => {
        return {componentData: {}}
      }
    }
  },
  name: "",
  components: {
    AloneImageSetting,
    AloneData
  },
  data() {
    return {
      showList: true,
      currentData: {},
      imageList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.data.componentData || !this.data.componentData.length) {
        this.imageList = [
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: "690*250"},
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: "690*250"},
        ];
      } else {
        this.imageList = this.data.componentData;
      }
    },
    // 添加一个新的
    addNew() {
      this.imageList.push({text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: "690*250"});
      this.currentData = this.imageList[this.imageList.length - 1];
      this.showList = false;
    },
    toSetting(data, idx) {
      this.currentData = data;
      this.currentIndex = idx;
      this.showList = false;
    },
    // 数据变更
    changeData() {
      this.imageList[this.currentIndex] = this.currentData;
      // 将数据向上级提交
      this.$emit("change", {
        ...this.data,
        componentData: this.imageList
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>